import _regeneratorRuntime from "D:/wenge-Obj/zhichuan/llm-agent-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/wenge-Obj/zhichuan/llm-agent-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Vue from 'vue';
import VueRouter from 'vue-router';
// import Cookie from 'js-cookie'
// import { ElMessage} from 'element-plus';
import { Message } from "element-ui";
import { authorizationApi, Login } from '@/api/index';
import { decryptData } from "@/utils/tool";
import md5 from "js-md5";
import { SUCCESS_CODE } from "@/api/config";
import app from '../main';
Vue.use(VueRouter);

// 完整路由代码
var router = new VueRouter({
  routes: [{
    path: '/',
    redirect: '/home'
  }, {
    path: '/login',
    name: 'login',
    component: function component() {
      return import('@/views/Login/Login');
    }
  }, {
    path: '/home',
    name: 'home',
    component: function component() {
      return import('@/views/Home/Home');
    }
  }, {
    path: '/form',
    name: 'FormPage',
    component: function component() {
      return import('@/views/Home/Form');
    }
  }, {
    path: '/privacyAgreement',
    name: 'privacyAgreement',
    component: function component() {
      return import('@/views/userCenter/privacyAgreement.vue');
    }
  }, {
    path: '/userAgreement',
    name: 'userAgreement',
    component: function component() {
      return import('@/views/userCenter/userAgreement.vue');
    }
  }, {
    path: '/homepage',
    component: function component() {
      return import('@/views/Main');
    },
    children: [{
      path: '/storemanage',
      name: 'storemanage',
      component: function component() {
        return import('@/views/storemanage/index');
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/manual',
      name: 'manual',
      component: function component() {
        return import('@/views/manual/index');
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/messageCenter',
      component: function component() {
        return import('@/views/systemManage/messageCenter/index');
      },
      meta: {
        requiresAuth: true
      },
      children: [{
        path: '',
        name: 'messageCenter',
        component: function component() {
          return import('@/views/systemManage/messageCenter/home/center');
        },
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'update',
        name: 'messageCenterUpdate',
        component: function component() {
          return import('@/views/systemManage/messageCenter/home/update');
        },
        meta: {
          requiresAuth: true
        }
      }]
    }, {
      path: '/appmanage/:openDialog?',
      name: 'appmanage',
      component: function component() {
        return import('@/views/appManage/index');
      },
      props: true,
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/operationsManagement',
      name: 'operationsManagement',
      component: function component() {
        return import('@/views/operationsManagement/operationsManagement');
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/intelligentSearch',
      name: 'intelligentSearch',
      component: function component() {
        return import('@/views/intelligentSearch/index');
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/systemManage/suggestionFeedback',
      name: 'suggestionFeedback',
      component: function component() {
        return import('@/views/systemManage/suggestionFeedback/index');
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/systemManage/cooperation',
      name: 'cooperationConsultation',
      component: function component() {
        return import('@/views/systemManage/cooperation/index');
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/systemManage/modelSupplier',
      name: 'modelSupplierManage',
      component: function component() {
        return import('@/views/systemManage/modelSupplier/index');
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/messageCenter',
      name: 'messageCenter',
      component: function component() {
        return import('@/views/systemManage/messageCenter/index');
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/systemManage/tenantManage',
      name: 'tenantManage',
      component: function component() {
        return import('@/views/tenantManage/tenantManage');
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/systemManage/roleManage',
      name: 'roleManage',
      component: function component() {
        return import('@/views/RoleManage/RoleManage');
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/systemManage/listingReview',
      name: 'listingReview',
      component: function component() {
        return import('@/views/systemManage/listingReview/index');
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/kbm',
      name: 'kbm',
      component: function component() {
        return import('@/views/Kbm/Kbm');
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/xgkbm',
      name: 'xgkbm',
      component: function component() {
        return import('@/views/xgKbm/xgKbm');
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/mcp',
      name: 'mcp',
      component: function component() {
        return import('@/views/mcp/index');
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/dataSj',
      name: 'dataSj',
      component: function component() {
        return import('@/views/dataSj/index');
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/keyManage',
      name: 'keyManage',
      component: function component() {
        return import('@/views/keyManage');
      },
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: '/ModelManagement',
    //   name: 'ModelManagement',
    //   component: () => import('@/views/system/ModelManagement'),
    //   meta: {
    //     requiresAuth: true
    //   },
    // },
    {
      path: '/systemManage/userManage',
      name: 'userManage',
      component: function component() {
        return import('@/views/UserManage/UserManage');
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/matterManage',
      name: 'matterManage',
      component: function component() {
        return import('@/views/MatterManage/index');
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/systemManage/menuManage',
      name: 'menuManage',
      component: function component() {
        return import('@/views/systemManage/menuManage/menuManage.vue');
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/workflow/workflowConfig',
      name: 'workflow',
      component: function component() {
        return import('@/views/workflowConfig/index.vue');
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/workflow/workFlowEdit',
      name: 'workFlowEdit',
      component: function component() {
        return import('@/views/workflowConfig/workFlowEdit.vue');
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/systemManage/operateLog',
      name: 'operateLog',
      component: function component() {
        return import('@/views/operate-log/index');
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/systemManage/userCenter',
      name: 'userCenter',
      component: function component() {
        return import('@/views/userCenter/index');
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/systemManage/dialogTemplate',
      name: 'dialogTemplate',
      component: function component() {
        return import('@/views/dialogTemplate/index');
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/tool',
      name: 'toolManager',
      component: function component() {
        return import('@/views/toolManager/index');
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/effectEvaluation',
      name: 'effectEvaluation',
      component: function component() {
        return import('@/views/effectEvaluation/index');
      },
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: '/toolManager/voice',
    //   name: 'voice',
    //   component: () => import('@/views/toolManager/voice/index'),
    //   meta: {
    //     requiresAuth: true
    //   },
    // },
    // {
    //   path: '/toolManager/prompt',
    //   name: 'prompt',
    //   component: () => import('@/views/toolManager/promptWordLibrary/index'),
    //   meta: {
    //     requiresAuth: true
    //   },
    // },
    {
      path: '/toolManager/scene',
      name: 'sceneManagement',
      component: function component() {
        return import('@/views/toolManager/scene');
      },
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: '/toolManager/largeModel',
    //   name: 'largeModel',
    //   component: () => import('@/views/toolManager/largeModel/index'),
    //   meta: {
    //     requiresAuth: true
    //   },
    // },
    {
      path: '/embadingManage',
      name: 'modelmanagement',
      component: function component() {
        return import('@/views/modelManagement/index');
      },
      meta: {
        requiresAuth: true
      }
    },
    // {
    //     path: '/embadingManage',
    //     name: 'vectorModel',
    //     component: () => import('@/views/toolManager/vectorModel/index'),
    //     meta: {
    //       requiresAuth: true
    //     },
    //   },
    {
      path: '/password',
      name: 'password',
      component: function component() {
        return import('@/views/Login/password');
      },
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: '/issueManagement',
    //   name: 'issueManagement',
    //   component: () => import('@/views/issueManagement/index'),
    //   meta: {
    //     requiresAuth: true
    //   },
    // },
    // 事项处置
    {
      path: '/sceneManage/disposalOfMatters',
      name: 'disposalOfMatters',
      component: function component() {
        return import('@/views/issueManagement/matterDisposalPage');
      },
      meta: {
        requiresAuth: true
      }
    },
    // 事项管理
    {
      path: '/sceneManage/eventManagement',
      name: 'eventManagement',
      component: function component() {
        return import('@/views/issueManagement/matterTypePage');
      },
      meta: {
        requiresAuth: true
      }
    }]
  }]
});
router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(to, from, next) {
    var _location$hash, _location$hash2;
    var wxAccessToken, res, _to$query, _encodeURIComponent, _to$query2, _passwordValue$split$, authParams, passwordValue, user, pwd, params, _res, code, data, msg, _manageAccessToken, passwordExpiredTime, token, jumpUrl, _to$query3, ticket, _params, _res2, _code, _data, _msg, _manageAccessToken2, _passwordExpiredTime, manageAccessToken;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // 10/28新加微信认证功能
          console.log("to", to);
          console.log("from", from);
          if (!to.fullPath.includes('from=wechat')) {
            _context.next = 9;
            break;
          }
          wxAccessToken = sessionStorage.getItem('wxAccessToken'); // if (process.env.NODE_ENV == 'development') {
          //   sessionStorage.setItem('wxAccessToken', '2a766ed08690479fa31239fb218eb608');
          //   wxAccessToken = '2a766ed08690479fa31239fb218eb608';
          // }
          if (wxAccessToken) {
            _context.next = 9;
            break;
          }
          _context.next = 7;
          return authorizationApi({
            url: location.href,
            applicationId: ''
          });
        case 7:
          res = _context.sent;
          if (res !== null && res !== void 0 && res.data) {
            window.location.href = res.data;
          }
        case 9:
          if (!to.fullPath.includes("from=passwordFreeLogin")) {
            _context.next = 22;
            break;
          }
          authParams = (_to$query = to.query) !== null && _to$query !== void 0 && _to$query.auth ? (_encodeURIComponent = encodeURIComponent((_to$query2 = to.query) === null || _to$query2 === void 0 ? void 0 : _to$query2.auth)) === null || _encodeURIComponent === void 0 ? void 0 : _encodeURIComponent.replace(/%20/g, "+").replace(/%2F/g, "/").replace(/%2B/g, "+") : "";
          passwordValue = decryptData(decodeURIComponent(authParams));
          user = passwordValue === null || passwordValue === void 0 || (_passwordValue$split$ = passwordValue.split("user=")[1]) === null || _passwordValue$split$ === void 0 ? void 0 : _passwordValue$split$.split("&pwd=")[0];
          pwd = passwordValue === null || passwordValue === void 0 ? void 0 : passwordValue.split("pwd=")[1];
          if (!(user && pwd)) {
            _context.next = 22;
            break;
          }
          params = {
            mykey: md5(pwd),
            username: user
          };
          _context.next = 18;
          return Login(params);
        case 18:
          _res = _context.sent;
          console.log(_res);
          code = _res.code, data = _res.data, msg = _res.msg;
          if (SUCCESS_CODE === code) {
            _manageAccessToken = data.accessToken;
            passwordExpiredTime = data.passwordExpiredTime;
            sessionStorage.setItem("manageAccessToken", _manageAccessToken);
            sessionStorage.setItem("user", JSON.stringify(data.user));
            sessionStorage.setItem("permission", JSON.stringify(data.permission));
            sessionStorage.setItem("systemLogo", data.systemLogo || "");
            if (passwordExpiredTime) {
              Message({
                message: passwordExpiredTime,
                type: "success"
              });
            } else {
              Message({
                message: app.$t("successed"),
                type: "success"
              });
            }
            next('/appmanage');
          } else {
            Message({
              message: msg,
              type: "error"
            });
          }
        case 22:
          token = ((_location$hash = location.hash) === null || _location$hash === void 0 || (_location$hash = _location$hash.split("?portaltoken=")) === null || _location$hash === void 0 ? void 0 : _location$hash.length) > 1 ? (_location$hash2 = location.hash) === null || _location$hash2 === void 0 ? void 0 : _location$hash2.split("?portaltoken=")[1] : "";
          jumpUrl = location.href ? location.href : "";
          if (token) {
            sessionStorage.setItem('loginToken', token);
            sessionStorage.setItem('jumpUrl', jumpUrl);
          }
          // 闻歌云认证参数ticket、token
          if (!to.fullPath.includes("ticket=")) {
            _context.next = 48;
            break;
          }
          ticket = (_to$query3 = to.query) === null || _to$query3 === void 0 ? void 0 : _to$query3.ticket;
          _params = {
            ticket: ticket,
            loginType: 'cloudplatform'
          };
          _context.next = 30;
          return Login(_params);
        case 30:
          _res2 = _context.sent;
          _code = _res2.code, _data = _res2.data, _msg = _res2.msg;
          if (!(SUCCESS_CODE === _code)) {
            _context.next = 47;
            break;
          }
          if (_data.permission.length) {
            _context.next = 36;
            break;
          }
          Message({
            message: "暂无访问权限，请联系平台管理员",
            type: "error"
          });
          return _context.abrupt("return", false);
        case 36:
          _manageAccessToken2 = _data.accessToken;
          _passwordExpiredTime = _data.passwordExpiredTime;
          sessionStorage.setItem("manageAccessToken", _manageAccessToken2);
          sessionStorage.setItem("user", JSON.stringify(_data.user));
          sessionStorage.setItem("permission", JSON.stringify(_data.permission));
          sessionStorage.setItem("systemLogo", _data.systemLogo || "");
          //首次登录的加载图片
          sessionStorage.setItem("loadingImg", "true");
          if (_passwordExpiredTime) {
            Message({
              message: _passwordExpiredTime,
              type: "success"
            });
          } else {
            Message({
              message: app.$t("successed"),
              type: "success"
            });
          }
          next('/appmanage');
          _context.next = 48;
          break;
        case 47:
          Message({
            message: _msg,
            type: "error"
          });
        case 48:
          // 在这里执行你的拦截逻辑
          // 检查用户是否已登录
          manageAccessToken = sessionStorage.getItem('manageAccessToken');
          if (!manageAccessToken && to.path !== '/login' && to.path !== '/privacyAgreement' && to.path !== '/userAgreement' && to.path !== '/home' && to.path !== '/form') {
            if (!token) {
              Message({
                message: '登录已过期，请重新登录',
                type: 'warning'
              });
            }
            next({
              name: 'login'
            }); // 假设'Login'是你的登录页面的名称
          } else {
            next();
          }
        case 50:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
export default router;